var app = angular.module("leonardo");

var WorkFlowController = function (
  $scope,
  $state,
  $filter,
  $timeout,
  $rootScope,
  $q,
  TemplateWorkflowService,
  WorkFlowService,
  ngDialog,
  FilterService,
  AccountService,
  AuthDataService,
  AccountUserService,
  PropertyService,
  PermissionService
) {

  $scope.items = [];
  $scope.expanded = false;
  $scope.workflow = $scope.$parent.workflow;
  $scope.tree_items = [];
  $scope.by_unit = $state.current.by_unit;
  $scope.selectedAccount = null;
  $scope.isAccountOwner = PermissionService.isOwner();
  // for enabling scheduling feature only for greystar
  let AccountIdsScheduleWF = [75, 31];
  
  $scope.checkEnableScheduling = function (){
    if(AccountIdsScheduleWF.includes(AccountUserService.currentAccountUser.account)){
      return true;
    }
    return false;
  }

  $scope.getLag = function (template) {
    if (!isNull(template.lag_days)) {
      return template.lag_days + ' days';
    }
    if (!isNull(template.lag_weeks)) {
      return template.lag_weeks + ' weeks';
    }
    if (!isNull(template.lag_months)) {
      return template.lag_months + ' months';
    }
    return '';
  };

  $scope.initTemplates = function (templates) {
    templates = $filter('orderBy')(templates, 'follow_on_level', true);
    angular.forEach(templates, function (value) {
      if (value.follow_on) {
        angular.forEach(templates, function (parent_value) {
          if (parent_value.id == value.follow_on) {
            if (!parent_value.templates)
              parent_value.templates = [];
            parent_value.templates.push(value);
          }
        });
      }
    });
    var templates_aux = [];
    angular.forEach(templates, function (value) {
      if (!value.follow_on) {
        templates_aux.push(value);
      }
    });
    $scope.tree_items = $scope.orderTemplates(templates_aux);
    return $scope.concatTemplates($scope.tree_items, []);
  };

  $scope.orderTemplates = function (templates) {
    var templates_aux = angular.copy(templates);
    angular.forEach(templates_aux, function (template) {
      if (template.templates)
        template.templates = $scope.orderTemplates(template.templates);
    });
    return $filter('orderBy')(templates_aux, 'id');
  };

  $scope.concatTemplates = function (templates, $results) {
    angular.forEach(templates, function (template) {
      $results.push(template);
      if (template.templates)
        $results.concat($scope.concatTemplates(template.templates, $results));
    });
    return $results;
  };

  $scope.getClassItem = function (item) {
    var classes = [];
    if (item.follow_on) {
      classes.push('child');
      classes.push(item.follow_on_level);
    }
    return classes;
  };

  $scope.tabbItems = function () {
    angular.forEach(angular.element('.child'), function (value) {
      var classes = value.classList;
      var follow_level = classes[classes.length - 2];
      var padding = 10 + (follow_level * 10);
      angular.element(value).css({paddingLeft: padding});
    });
  };

  $scope.expand = function () {
    if ($scope.expanded) {
      $scope.expanded = false;
      return;
    }
    $scope.expanded = true;
  };

  $scope.showItemEditDialog = function (template) {
    TemplateWorkflowService.get(template.id).then(function (data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/workflow/item/add.html',
        controller: 'WorkFlowItemAddDialog',
        className: 'ngdialog-theme-default ngdialog-template-add',
        data: {
          template: data,
          action: 'edit',
          workflow: $scope.workflow,
          by_unit: $scope.by_unit
        }
      }).then(function () {
        $scope.refresh();
      });
    });
  };

  $scope.showItemAddDialog = function (template) {
    var parent = template ? TemplateWorkflowService.get(template.id) : null;
    $q.when(parent).then(function (data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/workflow/item/add.html',
        controller: 'WorkFlowItemAddDialog',
        className: 'ngdialog-theme-default ngdialog-template-add',
        data: {
          template: null,
          action: 'create',
          follow_on: template ? template.id : null,
          parent: data,
          workflow: $scope.workflow,
          by_unit: $scope.by_unit,
        }
      }).then(function () {
        $scope.refresh();
      });
    });

  };

  $scope.refresh = function (init) {
    if (!init) {
      WorkFlowService.get($scope.workflow.id).then(function (data) {
        $scope.workflow = data;
        $scope.items = $scope.initTemplates(data.templates);
        $timeout($scope.tabbItems, 0);
        angular.forEach($scope.items, function (item) {
          item.enable = 1;
        });
      });
    } else {
      $scope.items = $scope.initTemplates($scope.workflow.templates);
      $timeout($scope.tabbItems, 0);
      angular.forEach($scope.items, function (item) {
        item.enable = 1;
      });
    }
  };

  $scope.toggleActive = function (item) {
    //use (+) sign to convert true or false into integer either 0 for false or 1 for true.
    item.enable = +!item.enable;
    if (!item.enable)
      $scope.enableChildren(item, 0);
  };

  $scope.enableChildren = function (template, enable) {
    angular.forEach($scope.haveChildren(template), function (item) {
      $scope.enableChildren(item, enable);
      item.enable = enable;
    });
  };

  $scope.haveChildren = function (template) {
    var results = [];
    angular.forEach($scope.items, function (item) {
      if (item.follow_on == template.id)
        results.push(item);
    });
    return results;
  };

  $scope.showMassWorkflowDialog = function (workflow) {
    function openDialogWithTimeout(dialogFunction, timeout) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          dialogFunction()
            .then(resolve)
            .catch(reject);
        }, timeout);
      });
    }
  
    function handleCatchError() {
      window.history.back();
    }
  
    function handlePropertySelection(property) {
      if (!property) {
        window.history.back();
        return Promise.reject();
      }

      var accountId = $scope.selectedAccount ? $scope.selectedAccount : workflow.account;
      var accountArray = accountId.toString().split(',');
      accountArray = accountArray.map(function(value) {
          return parseInt(value, 10);
      });
  
      if ($scope.by_unit) {
        return openUnitSelectDialog(property, workflow)
        .then((unitResult) => openDialogWithTimeout(() => openStartDateDialog(workflow, accountArray, property, unitResult), 200));
      } else {
        return openStartDateDialog(workflow, accountArray, property, null);
      }
    }
  
    function handleWorkflowDialog(account) {
      $scope.selectedAccount = account
      return openDialogWithTimeout(() => openPropertySelectorDialog($scope.selectedAccount), 200);
    }
  
    function handleAccountDialog() {
      return openDialogWithTimeout(openAccountDialog, 200)
        .then(handleWorkflowDialog)
        .then(handlePropertySelection)
        .catch(handleCatchError);
    }
  
    if (shouldOpenDialog()) {
      handleAccountDialog();
    } else {
      openDialogWithTimeout(() => openPropertySelectorDialog(workflow.account), 200)
        .then(handlePropertySelection)
        .catch(handleCatchError);
    }
  };
  
  function shouldOpenDialog() {
    return AccountService.getCollection().length > 1 && AuthDataService.isNotStaff();
  }
  
  function openAccountDialog() {
    return ngDialog.openConfirm({
      template: 'views/templates/dialog/account/select.html',
      controller: 'SelectAccountDialog',
      className: 'ngdialog-theme-default ngdialog-select-account',
      data: {
        permission: 'permission_add_workflow',
        actionName: 'massLaunch',
      },
    });
  }
  
  function openPropertySelectorDialog(account) {
    return ngDialog.openConfirm({
      controller: 'PortfolioPropertySelectorDialog',
      templateUrl: 'views/templates/dialog/portfolio/selector.html',
      data: {
        permission: 'permission_add_workflow',
        account: account,
        mode: 'properties'
      },
    });
  }
  
  function openUnitSelectDialog(property, workflow) {
    return ngDialog.openConfirm({
      controller: 'WorkFlowUnitSelectDialog',
      templateUrl: 'views/templates/dialog/workflow/unit-list.html',
      className: 'ngdialog-theme-default ngdialog-unit-add',
      data: {
        permission: 'permission_add_workflow',
        actionName: $scope.by_unit ? 'UWF' : 'WF',
        property: property.properties,
        workflow: workflow,
        actionButton: "massLaunch",
      },
    });
  }
  
  function openStartDateDialog(workflow, account, property, filterConditions) {
    return ngDialog.openConfirm({
      controller: 'SelectStartDate',
      templateUrl: 'views/templates/dialog/workflow/item/startDate.html',
      data: {
        permission: 'permission_add_workflow',
        actionName: $scope.by_unit ? 'UWF' : 'WF',
        workflow: workflow,
        account: account,
        property: property.properties,
        filter_conditions: filterConditions,
      },
    }).then();
  }
  

  $scope.showSelectWorkflowDialog = function () {
    var items_ids = [];
    angular.forEach($scope.items, function (value) {
      if (value.enable === 1) {
        items_ids.push(value.id);
      }
    });
    ngDialog.openConfirm({
      template: 'views/templates/dialog/workflow/launch.html',
      controller: 'LaunchWorkFlowDialog',
      data: {
        workflow: $scope.workflow,
        items: items_ids,
        property: FilterService.getFilter('property'),
        context: $scope.by_unit ? 'Launch Unit Workflow Page' : 'Launch Workflow Page'
      }
    }).then(function () {
      $timeout(function () {
        if ($scope.by_unit) {
          if (items_ids.length > 0) {
            $state.go('unit-turn.tasks');
          }
          else {
            $state.go('unit-turn.workflows-launch');
          }
        } else {
          if (items_ids.length > 0) {
            $state.go('workflows.workflows-instances');
          }
          else {
            $state.go('workflows.workflows-launch');
          }
        }
      }, 500);
    });
  };

  $scope.showItemDeleteDialog = function (template) {
    TemplateWorkflowService.get(template.id).then(function (data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/workflow/item/delete.html',
        controller: 'ItemDeleteDialog',
        data: {item: data}
      }).then(function () {
        $scope.refresh();
      });
    });
  };

  $scope.showWorkflowDeleteDialog = function (workflow) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/workflow/delete.html',
      controller: 'WorkFlowDeleteDialog',
      data: {workflow: workflow}
    }).then(function () {
      $rootScope.$broadcast('workflow:deleted');
    });
  };

  $scope.togglingRecurringWorkflow = function (workflow){
    let data = {};
    data.recurrence_enable = !workflow.recurrence_enable;
    WorkFlowService.toggleRecurrence(workflow.id , data).then(function () { 
      $rootScope.$broadcast('workflow:updated');
    })
  }

  $scope.refresh(true);

  $scope.$on('add-workflow-template', function (event, workflow_id) {
    if (workflow_id == $scope.workflow.id) {
      $scope.refresh();
    }
  });

};

app.controller('WorkFlowController', [
  '$scope',
  '$state',
  '$filter',
  '$timeout',
  '$rootScope',
  '$q',
  'TemplateWorkflowService',
  'WorkFlowService',
  'ngDialog',
  'FilterService',
  'AccountService',
  'AuthDataService',
  'AccountUserService',
  'PropertyService',
  'PermissionService',
  WorkFlowController
]);
